import React from 'react';
import { Button } from '@scholastic/volume-react';
import './HeaderLinks.scss';

export interface HeaderLinksProps {
  /**
   * It holds the click for previous 6 month
   */
  onPreviousClick: () => void;

  /**
   * It holds toggle between line/bar chart
   */
  toggleChartType: () => void;

  /**
   * It holds the click for next 6 month
   */
  onNextClick: () => void;
}

export const HeaderLinks = ({
  onPreviousClick,
  toggleChartType,
  onNextClick,
}: HeaderLinksProps) => {
  return (
    <div className="stats-chart-header m-2">
      <span className="stats-chart-header__links-panel">
        <Button
          className="stats-chart-header__links"
          onClick={() => onPreviousClick()}
          color="info"
          size="small"
          tag="a"
          link
          type="button"
          id="previous-report"
        >
          {'< Previous 6 months'}
        </Button>
      </span>

      <span className="stats-chart-header__links-panel stats-chart-header__links-panel--centre">
        <Button
          className="stats-chart-header__links"
          onClick={toggleChartType}
          color="info"
          size="small"
          tag="a"
          link
          type="button"
          id="toggle-chart"
        >
          {'Toggle Line/Bar'}
        </Button>
      </span>

      <span className="stats-chart-header__links-panel stats-chart-header__links-panel--right">
        <Button
          className="stats-chart-header__links"
          onClick={() => onNextClick()}
          color="info"
          size="small"
          tag="a"
          link
          type="button"
          id="next-report"
        >
          {'Next 6 months >'}
        </Button>
      </span>
    </div>
  );
};
